var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 878,
    viewBox: "0 0 483 878",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 50,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 780,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.5,
    cy: 875,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.5,
    cy: 871,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 859,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 479.5,
    cy: 664,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 729,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.5,
    cy: 616,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.5,
    cy: 536,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.5,
    cy: 374,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.5,
    cy: 33,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 336.5,
    cy: 109,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.5,
    cy: 3,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 639,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 320,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 440,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 268,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.5,
    cy: 448,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.940ec2eae0fd59ff2372afd52dc90542.svg";
export { ForwardRef as ReactComponent };